import React from "react";
import {
	Box,
	CircularProgress
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";

const WelcomeLoading = () => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>

			<img
				src={require("../../../assets/svg/logos/small-logo.svg").default}
				className={classes.logo}
			/>

			<CircularProgress
				className={classes.circularProgress}
			/>

		</Box>
	)
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		flex: 1,
		height: "100vh",
		background: theme.palette.background.default,
	},
	logo: {
		flex: 1,
		maxWidth: 124
	},
	circularProgress: {
		marginTop: -64,
		marginBottom: 64,

		"& .MuiCircularProgress-circle": {
			stroke: "#FB7800"
		}
	}
}));

export default WelcomeLoading
